<template>
  <canvas ref="canvas"></canvas>
</template>

<script>
import QRCode from 'qrcode'
export default {
  props: {
    value: {
      type: String,
    },
    size: {
      type: Number,
      default: 250
    },
  },
  watch: {
    value(val) {
      if(val) {
        this.generateQRCode(val)
      }
    }
  },
  methods: {
    generateQRCode(value) {
      QRCode.toDataURL(this.$refs.canvas, value, { errorCorrectionLevel: 'H', width: this.size }, function (error) {
        if (error) console.error(error)
        // console.log('success!')
      })
    }
  }
}
</script>
